<template>
<div class="start_page_box" v-if="$store.state.common.onload">
    <div class="blur_bg"></div>
    <div class="wrap" style="height:100vh; background:none">
    <!--
        <dl>
            <dt>
                상담에<br>
                <span>프리미엄</span>을 입히다
            </dt>
            <dd>
                오직 당신만을 위한 맞춤형<br>
                모바일 쇼륨 상담 예약 서비스
            </dd>
        </dl>
    -->    
        <div class="start_page_box_div">
            <button @click="$router.replace('/join/niceAuth')">전화번호로 가입하기</button>
            <p>이미 프리북 회원이라면? <router-link to="/login">로그인</router-link></p>
        </div>
       
    </div>
</div>

<!-- <div>
    <div class="finish_join">
        <div class="wrap">
            <dl>
                <dt></dt>
                <dd>
                    
                </dd>
            </dl>
            <div>
                <p>
                    나만을 위해 준비된<br>프리미엄 상담 예약 서비스
                </p>
                <img :src="$store.state.resource.imgPreebookLogoW">
            </div>
            
        </div>
    </div>   
    
    <div class="btn_box_fixed">
        <a @click="$router.replace('/login')" class="default_btn1">로그인</a>
        <a @click="$router.replace('/main')" class="later_login_btn">다음에 할게요</a>
    </div> 
</div> -->
</template>

<script>
export default {
    name: 'Intro',
    created () {
        this.$store.state.header = false;
        this.$store.state.headerBlank = false;
        if(this.auth.id > 0) this.$router.replace('/main')
        else this.$store.commit('SHOW_ONLOAD');
    },
};
</script>

<style lang="scss" scoped>

</style>